import { useEffect } from 'react';
import useOktaApi from './hooks/useOktaApi';
import { OKTA_BODY_ATTRIBUTE_NAME } from '../../constants';

const useOkta = ({ app }) => {
    const [{ isLoading = false }, { fetchOkta }] = useOktaApi();
    useEffect(() => {
        app.general = app.general || createConfigurableObject();

        const fetchData = async () => {
            const enabled = await fetchOkta();
            document.body.setAttribute(OKTA_BODY_ATTRIBUTE_NAME, enabled ? 'enabled' : 'disabled');
        };

        fetchData();
    }, []);

    return [
        {
            isLoading,
        },
        {},
    ];
};

export default useOkta;
